import { z } from 'zod';

export enum PurchaseOrderNumberFormKeys {
    purchaseOrderNumber = 'purchaseOrderNumber',
}

const MAX_PURCHASE_ORDER_NUMBER_LENGTH = 255;

export const PurchaseOrderNumberFormSchema = z.object({
    [PurchaseOrderNumberFormKeys.purchaseOrderNumber]: z
        .string()
        .max(MAX_PURCHASE_ORDER_NUMBER_LENGTH)
        .optional()
        .nullable()
        .transform((value) => ((value || '').trim() === '' ? null : value)),
});

export type PurchaseOrderNumberFormValues = z.infer<typeof PurchaseOrderNumberFormSchema>;
